export default "__VITE_ASSET__RogkgCl3__"